export function getMonthlyCellDisplay({
  hasFiles,
  isCurrentMonth,
  isMobile,
}) {
  return {
    showFileIndicators: hasFiles,
    showThumbnails: hasFiles && !isMobile,
    showAccentBorder: isCurrentMonth && hasFiles,
    mediaToneClass: isCurrentMonth ? "" : "opacity-75",
  };
}
